// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getGrade = createAsyncThunk('getGradeAllData/getGrade', async () => {
    try {
        let response = await axios.get('/EmployeeGrade', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getGradeOption = createAsyncThunk('getGradeAllData/getGradeOption', async () => {
    try {
        let response = await axios.get('/EmployeeGrade?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteGrade = createAsyncThunk('getGradeAllData/deleteGrade', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/EmployeeGrade/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Grade Delete Successfully.');
        await dispatch(getGrade());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createGrade = createAsyncThunk('getGradeAllData/createGrade', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/EmployeeGrade', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Grade added Successfully.');
        await dispatch(getGrade());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateGrade = createAsyncThunk('getGradeAllData/updateGrade', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/EmployeeGrade/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Grade update Successfully.');
        await dispatch(getGrade());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateGradeStatus = createAsyncThunk('getGradeAllData/updateGradeStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/EmployeeGrade/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getGrade());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const gradeSlice = createSlice({
    name: 'getGradeAllData',
    initialState: {
        grade: [],
        gradeOption: []
    },

    extraReducers: (builder) => {
        builder.addCase(getGrade.fulfilled, (state, action) => {
            state.grade = action?.payload;
            return;
        });
        builder.addCase(getGradeOption.fulfilled, (state, action) => {
            state.gradeOption = action?.payload;
            return;
        });
    }
});

export default gradeSlice.reducer;
